module.exports = __webpack_public_path__ + "img/heihachi.172fc086.jpg";